function cov_20ywe45xq3() {
  var path = "/Users/danny.su@opendoor.com/od/code/js/packages/cinderblocks/src/core/AddressInput/index.ts";
  var hash = "81a4172c5e3b814ce5a01c107919ba05fe16fd68";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Users/danny.su@opendoor.com/od/code/js/packages/cinderblocks/src/core/AddressInput/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "81a4172c5e3b814ce5a01c107919ba05fe16fd68"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_20ywe45xq3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_20ywe45xq3();
export { default } from "./AddressInput.mjs";
//# sourceMappingURL=index.mjs.map